import React from "react";

import {
  AuthLoginComponent,
  ScreenType
} from "@acko-tech/building-blocks.utils.auth-login-module";
import { useOnload } from "@utils/useOnLoad";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { setPayloadData } from "@store/slices/globalState";
import { isWebView } from "@utils/commonUtils";
import { getJourneyType } from "@utils/index";

const shouldSkipVerifyOtpForApp = () => {
  if (!isWebView()) return false;
  const journey = getJourneyType();
  return journey === "fresh_car";
};

const VerifyOtpContent = (props) => {
  const dispatch = useDispatch();
  const { globalPayloadData } = useSelector(({ globalState }: any) => {
    return {
      globalPayloadData: globalState?.payloadData
    };
  });

  const router = useRouter();
  const { current_node, proposal_ekey } = router.query;

  const {
    // id,
    // title,
    // subTitle,
    phone,
    // verifyOTPApiResp,
    // mobileNumberVerified,
    // proposalMobileNumber,
    // payloadData,
    actions
  } = props;

  const { on_edit_click, on_load, on_verify_success } = actions || {};

  useOnload({ on_load });

  const handleEditClick = () => {
    if (on_edit_click?.length > 0) {
      on_edit_click?.forEach((action) => {
        if (action && typeof action.funCall === "function") {
          action.funCall(action.args || {});
        }
      });
    }
  };

  const handleVerifySuccess = () => {
    if (
      on_verify_success?.[0] &&
      typeof on_verify_success[0].funCall === "function"
    ) {
      // Update global state with the current phone number
      dispatch(setPayloadData({ phone: phone }));

      // Create updated payload data with the current phone number
      const updatedPayloadData = {
        ...globalPayloadData,
        phone: phone // Use the current phone prop instead of globalPayloadData.phone
      };

      const payload = {
        current_node: current_node,
        data: {
          proposal_ekey: proposal_ekey,
          ...updatedPayloadData
        }
      };

      on_verify_success[0].funCall({
        shouldRedirect: true,
        ...payload,
        ...on_verify_success[0].args
      });
    }
  };

  return phone ? (
    <AuthLoginComponent
      clientId="auto-sdui-client"
      screen={ScreenType.OTP_INPUT_SCREEN}
      phoneNumber={phone}
      onEdit={() => {
        handleEditClick();
      }}
      onSuccess={() => {
        handleVerifySuccess();
      }}
    />
  ) : (
    <></>
  );
};

const verifyOtp = (props) => {
  if (shouldSkipVerifyOtpForApp()) {
    return null;
  }
  return <VerifyOtpContent {...props} />;
};

export default verifyOtp;
